export const translations = {
	'There are no assetgroups created.': {
		no: 'Ingen ressursgrupper er opprettet',
	},
	'Create assetgroup': {
		no: 'Lag ressursgruppe',
	},
	'Edit assetgroup': {
		no: 'Rediger ressursgruppe',
	},
	'Are you sure you want to remove assetgroup?': {
		no: 'Vil du slette ressursgruppen?',
	},
	'To delete assetgroup remove its dependencies. For application assetgroup will be removed, but you have to manually remove its shape.':
		{
			no: 'For å slette denne ressursgruppen må vi fjerne koblingene. For applikasjon vil ressursgruppe ID fjernes, men du må fjerne formen manuelt.',
		},
};
